/*
 * Session 4 (2/2): cart icon badge pop on count change + bottom-nav mirror.
 *
 * Dawn re-renders the cart bubble by replacing the innerHTML of the persistent
 * <a id="cart-icon-bubble"> (cart.js / cart-drawer.js getSectionsToRender), so
 * the .cart-count-bubble (and its count <span>) is a fresh node each add. We
 * therefore observe the STABLE #cart-icon-bubble subtree for text changes; when
 * the parsed count changes to a higher value (an add), we add a class that runs
 * the 0→1 scale pop, then strip it on animationend so it can fire again.
 *
 * Dawn's AJAX cart only re-renders THIS header bubble, never the mobile
 * bottom-nav badge (#elome-cart-count) — which Liquid renders correctly on page
 * load but would otherwise go stale after every dynamic add-to-cart. So we also
 * mirror the live count into that badge on each change; the existing CSS
 * `.elome-bottom-nav__count:not(:empty) { display: flex }` rule shows/hides it.
 */
(function () {
  'use strict';

  var iconBubble = document.getElementById('cart-icon-bubble');
  if (!iconBubble || typeof MutationObserver === 'undefined') return;

  var bottomBadge = document.getElementById('elome-cart-count');

  function readCount() {
    var bubble = iconBubble.querySelector('.cart-count-bubble');
    if (!bubble) return 0;
    var span = bubble.querySelector('span[aria-hidden="true"]') || bubble;
    var n = parseInt(span.textContent, 10);
    return isNaN(n) ? 0 : n;
  }

  // Empty text → CSS `:not(:empty)` keeps it hidden; digits → it shows.
  function syncBadge(count) {
    if (!bottomBadge) return;
    bottomBadge.textContent = count > 0 ? String(count) : '';
  }

  var prevCount = readCount();
  syncBadge(prevCount);

  function pop() {
    var bubble = iconBubble.querySelector('.cart-count-bubble');
    if (!bubble) return;
    // Restart cleanly if a pop is already mid-flight on this (new) node.
    bubble.classList.remove('elome-cart-pop');
    void bubble.offsetWidth; // force reflow so the animation can re-trigger
    bubble.classList.add('elome-cart-pop');
    bubble.addEventListener(
      'animationend',
      function () {
        bubble.classList.remove('elome-cart-pop');
      },
      { once: true }
    );
  }

  var observer = new MutationObserver(function () {
    var count = readCount();
    if (count !== prevCount && count > 0) pop();
    syncBadge(count);
    prevCount = count;
  });

  observer.observe(iconBubble, { childList: true, subtree: true, characterData: true });
})();

/*
 * Fix: stop the cart drawer auto-opening on add-to-cart.
 *
 * Dawn opens the drawer programmatically as part of the add-to-cart flow
 * (CartDrawer.renderContents and product-form both reach CartDrawer.open()).
 * Commenting out the call in cart-drawer.js wasn't enough — another path still
 * fires open(). So gate the method itself: the patched open() only runs the
 * original when the customer themselves invoked the cart icon, tracked via a
 * one-shot flag. Programmatic opens (the add flow) leave the flag false and are
 * suppressed; the cart count badge and drawer contents still update in place.
 *
 *   • window.elomeCartManualOpen defaults to false.
 *   • A capture-phase listener on #cart-icon-bubble sets it true on a real user
 *     click or Space/Enter keydown — capture runs BEFORE Dawn's own bubble-phase
 *     handler that calls open(), so the flag is set in time.
 *   • The patched open() calls the original only when the flag is true, then
 *     resets it to false so the next (programmatic) open stays suppressed.
 */
(function () {
  'use strict';

  if (typeof window.customElements === 'undefined') return;

  window.elomeCartManualOpen = false;

  // Mark the next open() as customer-initiated. Capture phase so this runs
  // before Dawn's click/keydown handler (added in CartDrawer's constructor)
  // invokes open().
  function flagManual() {
    window.elomeCartManualOpen = true;
  }

  function wireCartIcon() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon || cartIcon.dataset.elomeManualWired) return;
    cartIcon.dataset.elomeManualWired = 'true';
    cartIcon.addEventListener('click', flagManual, true);
    cartIcon.addEventListener(
      'keydown',
      function (event) {
        var code = (event.code || '').toUpperCase();
        if (code === 'SPACE' || code === 'ENTER') flagManual();
      },
      true
    );
  }

  // Gate CartDrawer.open(): only the customer-initiated open is allowed through.
  window.customElements.whenDefined('cart-drawer').then(function () {
    var ctor = window.customElements.get('cart-drawer');
    if (!ctor || ctor.prototype.elomeOpenPatched) return;

    var originalOpen = ctor.prototype.open;
    ctor.prototype.open = function () {
      if (window.elomeCartManualOpen) {
        window.elomeCartManualOpen = false;
        return originalOpen.apply(this, arguments);
      }
      // Programmatic (add-to-cart) open — suppress, but keep the flag clean.
      window.elomeCartManualOpen = false;
    };
    ctor.prototype.elomeOpenPatched = true;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireCartIcon);
  } else {
    wireCartIcon();
  }
})();

